var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbars',{attrs:{"objects":_vm.messages},on:{"update:objects":function($event){_vm.messages=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }